<template>
  <div class=" project_detail">
    <mt-header title="展商收藏 ">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    采购管理开发中......
  </div>
</template>

<script>
import { Header } from 'mint-ui';
export default {
  components:{
    'mt-header':Header
  }

}
</script>

<style>

</style>